import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#005B53',
                error: '#b71c1c',
                background: '#f6f6f6', // Not automatically applied

            },
            
        },
        icons: {
            iconfont: 'fa',
        }
    }
});
